import { ArrowUpRight } from "lucide-react";

export const ContentCard = ({ item }) => (
  <article data-testid="content-card" className="group border border-border-light bg-white transition-shadow hover:shadow-lg">
    <div className="relative aspect-video overflow-hidden">
      <img
        src={item.image.url}
        alt={item.image.alt}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute left-3 top-3 bg-brand-purple px-3 py-1 font-subheading text-[11px] font-semibold uppercase tracking-widest text-white">
        {item.category}
      </span>
    </div>
    <div className="p-6">
      <h3 className="font-heading text-2xl uppercase leading-tight text-brand-black">Content title goes here</h3>
      <p className="mt-2 text-sm text-black/60">Content description goes here</p>
      <button type="button" data-testid="content-card-read-more" className="mt-4 inline-flex items-center gap-1 font-subheading text-xs font-semibold uppercase tracking-widest text-brand-purple">
        Read more <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </div>
  </article>
);
